module.exports = __webpack_public_path__ + "img/3dForm5.57342b23.svg";